import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/windDirection.svg'


const _hoisted_1 = { class: "wp1200 withPadding" }
const _hoisted_2 = { class: "mainTitle" }
const _hoisted_3 = { class: "singleCity" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "city" }, "Logatec", -1)
const _hoisted_5 = { class: "detailInfo" }
const _hoisted_6 = { class: "flex icon" }
const _hoisted_7 = {
  ref: "canvas",
  height: "300"
}
const _hoisted_8 = { class: "temperature" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "celcius" }, "°C", -1)
const _hoisted_10 = { class: "data" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_rel-vlaznost" }, null, -1)
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_zracni-tlak" }, null, -1)
const _hoisted_14 = { class: "mbar" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_arrow-L" }, null, -1)
const _hoisted_16 = { class: "flex top" }
const _hoisted_17 = { class: "flex responsive" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_wind" }, null, -1)
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "dayAndDate" }
const _hoisted_21 = { class: "day green" }
const _hoisted_22 = { class: "date" }
const _hoisted_23 = { class: "tempInfo flex" }
const _hoisted_24 = { class: "green" }
const _hoisted_25 = { class: "hourlyWeather" }
const _hoisted_26 = { class: "listedDays" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1)
const _hoisted_28 = { class: "singleDay flex" }
const _hoisted_29 = { class: "time" }
const _hoisted_30 = { class: "temp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_WeatherChart = _resolveComponent("WeatherChart")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("weather.title")), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("canvas", _hoisted_7, null, 512),
          _createElementVNode("span", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.currently.temperature), 1),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.currently.timeString), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.currently.summary), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_11,
              _createTextVNode(_toDisplayString(_ctx.currently.humidity) + "% ", 1)
            ]),
            _createElementVNode("li", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.currently.pressure) + " hPa", 1),
              _hoisted_15
            ]),
            _createElementVNode("li", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.currently.windSpeed) + " m/s", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.currently.windDirection), 1)
                ])
              ]),
              _createElementVNode("img", {
                style: _normalizeStyle({
                  transform: 'rotate(' + _ctx.currently.windBearing + 'deg)',
                }),
                src: _imports_0,
                alt: ""
              }, null, 4)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Accordion, {
      activeIndex: 0,
      class: "dailyWeather"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daily.data, (weather) => {
          return (_openBlock(), _createBlock(_component_AccordionTab, { key: weather }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$moment.unix(weather.time).format("dddd")), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(weather.timeString), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["weatherIcon", weather.icon])
                  }, null, 2),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(weather.temperatureHigh) + "°C", 1),
                  _createElementVNode("span", null, _toDisplayString(weather.temperatureLow) + "°C", 1)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_swiper, {
                    breakpoints: _ctx.breakpoints,
                    modules: _ctx.modules,
                    pagination: { el: 'swiper-pagination', clickable: true }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weather.hourly, (hourlyData) => {
                        return (_openBlock(), _createBlock(_component_swiper_slide, { key: hourlyData }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("span", _hoisted_29, _toDisplayString(hourlyData.timeString), 1),
                              _createElementVNode("span", {
                                class: _normalizeClass(["weatherIcon", hourlyData.icon])
                              }, null, 2),
                              _createElementVNode("span", _hoisted_30, _toDisplayString(hourlyData.temperature) + "°C", 1)
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["breakpoints", "modules"])
                ]),
                _createVNode(_component_WeatherChart, {
                  percentage: 65,
                  "left-text": "7:35",
                  "right-text": "19:35"
                })
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}